import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { CommonService } from '../../services/common.service';
import { HttpService } from '../../services/http-service.service';
import { LogService } from 'src/app/services';
import { ZipProvider } from 'src/app/providers/bvq';
@Component({
  selector: 'app-add-block-location',
  templateUrl: './add-block-location.component.html',
  styleUrls: ['./add-block-location.component.scss']
})

export class AddBlockLocationComponent implements OnInit, OnDestroy {

  subject: Subject<any>;
  subscription: any;
  address: string = '';
  zip: number;
  state: string = '';
  city: string = '';
  showZipLoading: boolean = false;

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    public commonService: CommonService,
    public httpService: HttpService,
    private logService: LogService,
    private zipProvider: ZipProvider,
  ) { }

  ngOnInit(): void {
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc') {
        this.onCancel();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onConfirm(): void {
    this.bsModalRef.hide();
    this.subject.next({
      ADDRESS: this.address,
      CITY: this.city,
      STATE: this.state,
      ZIP: this.zip,
    });
    this.subject.complete();
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }

  // getAddressBasedOnZip() - Get city and state based on zip
  getAddressBasedOnZip(): void {
    if (this.zip.toString().length == 5) {
      this.showZipLoading = true;
      this.httpService.getAddressBasedOnZip(this.zip).subscribe((resp) => {
        if (resp.success && resp.result) {
          this.state = resp.result.STATE;
          this.city = resp.result.CITY;
        }
        this.showZipLoading = false;
      }, (error) => {
        if (error) {
          this.showZipLoading = false;
          this.logService.log(error.message);
        }
      });
    }
  }

  zipEntered(): void {
    this.zipProvider.identifyZip(this.zip.toString())
      .subscribe(
        data => {

          if (data.success) {
            if (data.result) {
              this.state = data.result.STATE;
              this.city = data.result.CITY;
            }
          }
        }, (error) => {
          if (error) {
            this.showZipLoading = false;
            this.logService.log(error.message);
          }
        });
  }
}
